import React from "react";
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import {keywordFilters} from "../../@signals";


export default function nameColumn(name, label, showActions=false) {
    return {
        name: name, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => {
                return <Box display="flex" justifyContent="center" alignItems="center">
                    {value}
                    {!!showActions && <IconSeeker
                        icon="pen"
                        tooltip="Modify Keyword"
                        sx={{ fontSize: '1rem', cursor: 'pointer', ml: 1 }}
                        onClick={() => {
                            return keywordFilters.value = {
                            customerID: row.customerID,
                            createMode: false,
                            categoryID: !!row.categoryID ? row.categoryID : null,
                            keywordName: row.keywordName,
                            keywordID: row.keywordID,
                            keywordType: row.keywordTypeID,
                            siteID: !!row.siteID ? [row.siteID] : [],
                            oldCustomerID: row.customerID,
                            oldSiteID: row.oldSiteID
                        }}}
                    />}
                </Box>
            }
        }
    }
}